// extracted by mini-css-extract-plugin
export var active = "_ed-2";
export var recordingDot = "_ed-1";
export var recordingIndicator = "_ed-0";